module.exports = __webpack_public_path__ + "img/test_before.b5b30dff.jpg";